import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const GAME_UUID = "b6cc4d07-31af-4702-b011-ff231d738b4e";

const battleRiseQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-wishlist-added`,
    ruleId: `${GAME_UUID}-wishlist`,
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch the Battle Rise Trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "iframe/embed",
    videoUrl: "https://youtu.be/c5bOaUfiqtQ",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-trailer-event`,
    ruleId: `${GAME_UUID}-trailer`,
  },
  {
    type: "link",
    key: "telegram-v2",
    icon: "Telegram",
    label: "Join Telegram Channel",
    caption: "Get the latest updates",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-telegram-event`,
    ruleId: `${GAME_UUID}-telegram`,
    linkUrl: "https://web.telegram.org/k/#@TriumphGames",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow Battle Rise on X",
    caption: "Don't miss a tweet",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-twitter-battlerise-game-event`,
    ruleId: `${GAME_UUID}-twitter-battlerise-game`,
    linkUrl: "https://x.com/battlerisegame",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow Triumph Studios on X",
    caption: "Stay updated with the developers",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-twitter-triumph-game-event`,
    ruleId: `${GAME_UUID}-twitter-triumph-game`,
    linkUrl: "https://x.com/Triumph_Games",
  },
];

const battleRiseQuestsLvl2: Quest[] = [
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord Community",
    caption: "Connect with players and join the discussion",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-discord-event`,
    ruleId: `${GAME_UUID}-discord`,
    linkUrl: "https://discord.com/invite/BattleRise",
    waitTimeInHrs: 24,
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Download the game",
    caption: "Dive into the Battle Rise universe",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-download-game-event`,
    ruleId: `${GAME_UUID}-download-game`,
    linkUrl: "https://www.battlerise.com/play",
  },
];

export const battleRiseQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      title: "Learn and connect",
      description: "Level 1 Supporter",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +25 <icon> Gems",
    totalGemsGranted: 25,
    hideOnCompletion: true,
    lockedUntilPrevious: true,
    quests: battleRiseQuestsLvl1,
    // introModal: {
    //   title: "You're on your way to Level 1",
    //   description:
    //     "Thanks for following Battle Rise. Keep showing your support and earn better perks while doing it.",
    //   foregroundImage:
    //     "https://images.prismic.io/imtbl-player-portal/battlerise-level1.webp?auto=format,compress", // TODO: Update with actual image URL
    // },
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Dive deeper",
      description: "Level 2 Believer",
    },
    nextQuest: {
      url: "/games/overknights",
      title: "Thanks for getting involved",
      label: "Want more? Check out Overknights",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +25 <icon> Gems",
    totalGemsGranted: 25,
    hideOnCompletion: false,
    lockedUntilPrevious: true,
    quests: battleRiseQuestsLvl2,
    // introModal: {
    //   title: "Level 2, here you go",
    //   description:
    //     "People like you are making Battle Rise a better and bigger game. Let's keep at it.",
    //   foregroundImage:
    //     "https://images.prismic.io/imtbl-player-portal/battlerise-level2.webp?auto=format,compress", // TODO: Update with actual image URL
    // },
    // exitModal: {
    //   title: "That's all folks",
    //   description:
    //     "Level 2 Believer achieved. Bigger and better quests are on the horizon!",
    //   foregroundImage:
    //     "https://images.prismic.io/imtbl-player-portal/battlerise-complete.webp?auto=format,compress", // TODO: Update with actual image URL
    // },
  },
];
